"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  links: {
    "& ul": {
      listStyle: "disc",
      margin: "1em 0"
    },
    "& ol": {
      listStyle: "upper-roman",
      margin: "1em 0"
    },
    "& strong": {
      fontWeight: "bold"
    },
    "& em": {
      fontStyle: "italic"
    }
  }
}));

const ArticleLinks = ({
  className,
  language = "no",
  links = []
}) => {
  const localeId = "locale:" + language;
  const classes = useStyles();

  const renderLink = ({
    title,
    url
  }) => {
    if (typeof title === "object") {
      title = title[localeId] || undefined;
    }

    return _react.default.createElement("li", null, _react.default.createElement("a", {
      href: url
    }, title));
  };

  if (!links.length) {
    return false;
  }

  return _react.default.createElement("div", {
    className: className || classes.links
  }, _react.default.createElement("ul", null, links.map(link => renderLink(link))));
};

var _default = ArticleLinks;
exports.default = _default;
module.exports = exports.default;